import { Link } from "react-router-dom";
import { RELATED_TYPE_LABELS, type RelatedType } from "@shared/modules/x-messagerie";

const ROUTES: Partial<Record<RelatedType, string>> = {
  appointment: "/travaux",
  warranty: "/garanties",
  client: "/clients",
};

/** Lien vers l'objet auquel un message se rattache (travail, garantie, client). */
export function RelatedLink({ type, id }: { type: RelatedType | null; id: string | null }) {
  if (!type || !id) return <span className="messages__muted">—</span>;
  const base = ROUTES[type];
  if (!base) {
    return (
      <span className="messages__related">
        {RELATED_TYPE_LABELS[type]} · {id}
      </span>
    );
  }
  return (
    <Link className="messages__related" to={`${base}/${id}`}>
      {RELATED_TYPE_LABELS[type]}
    </Link>
  );
}
